import React from "react";
import { Route, Routes } from "react-router-dom";
import { MembersPage } from "./MembersPage";
import { ChatPage } from "./ChatPage";

export const TeamPage: React.FC = () => {
	return (
		<Routes>
			<Route
				path="/"
				element={<MembersPage />}
			/>
			<Route
				path="/chat"
				element={<ChatPage />}
			/>
		</Routes>
	);
};
